import { KeyValue } from '@mews/enums';

/**
 * Data attributes used by the Tabs component for DOM querying and identification
 */
export const TAB_DATA_ATTRIBUTES = {
    /** Unique identifier for each tab, used for keyboard navigation and DOM queries */
    TAB_VALUE: 'data-tab-value',

    /** Indicates which tab is currently active/selected */
    TAB_ITEM_ACTIVE: 'data-tab-item-active',

    /** Test identifier for the tab element */
    TEST_TAB: 'data-test-tab',

    /** Test identifier indicating if the tab is active */
    TEST_TAB_ACTIVE: 'data-test-tab-active',
} as const;

/**
 * Selector strings for querying tab elements
 */
export const TAB_SELECTORS = {
    ACTIVE_TAB: `[${TAB_DATA_ATTRIBUTES.TAB_ITEM_ACTIVE}="true"]`,
} as const;

/**
 * Keys that trigger navigation between tabs
 */
export const TAB_NAVIGATION_KEYS = [
    `${KeyValue.ArrowLeft}`,
    `${KeyValue.ArrowUp}`,
    `${KeyValue.ArrowRight}`,
    `${KeyValue.ArrowDown}`,
    `${KeyValue.Home}`,
    `${KeyValue.End}`,
];
